import React, { FunctionComponent } from 'react';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

import { displayPrice } from '../../helpers/draindown';
import { CounterButtons } from '../CounterButtons/CounterButtons';
import styles from './ServiceCardActionBar.module.scss';

interface ServiceCardActionBarProps {
  service: DrainDownAdditionalService;
  handleChange: (data: DrainDownSelectedAdditionalService) => void;
  quantity: number;
}

const ServiceCardActionBar: FunctionComponent<ServiceCardActionBarProps> = ({
  service,
  handleChange,
  quantity,
}) => {
  return (
    <div className={styles.cardActionBar}>
      <p>
        {service.name} <span>{displayPrice(service.price)}</span>
      </p>
      {service.type === 'simple' && (
        <Button
          data-testid={`${service.tag}-${quantity ? 'remove' : 'add'}`}
          size="small"
          variant="outlined"
          onClick={() => handleChange({ service, quantity: quantity ? 0 : 1 })}
        >
          {quantity ? 'Remove' : 'Add'}
        </Button>
      )}
      {service.type === 'counter' && (
        <div style={{ minWidth: 102 }}>
          <CounterButtons
            count={quantity}
            onDecrement={() =>
              handleChange({ service, quantity: quantity - 1 })
            }
            onIncrement={() =>
              handleChange({ service, quantity: quantity + 1 })
            }
          />
        </div>
      )}
    </div>
  );
};

export default ServiceCardActionBar;
